/**
 * Creates a /marketplace path
 * @param path - The path to appended to /marketplace
 */
export const getMarketplacePath = path => {
  return `/marketplace${path.replace(/\/+$/, '')}`;
};